<template>
  <customModal :containersm="true" @closeModal="closeModal()">
    <template #title>
      Change Planned Date
    </template>
    <template #body>
      <div class="p-0">
        <div class="col-lg-12 my-0">
          Visit Name: {{ visitobj.visitName }}
        </div>
            <div class="col-lg-12 my-0">
                <label class="col-form-label">
                    Date
                    
                </label>
                <flat-pickr
                  v-model="datetimefield"
                  :config="dateTimePickerConfig"
                  class="fp-datetime-input"
                />
            </div>
           <div class="col-lg-12 mt-4 d-flex justify-content-lg-end">
                <button
                    class="save_btn py-1 px-4"
                    type="button"
                    @click.prevent="createSchedule"
                    :disabled="isCreating"
                    >
                    <span v-if="isCreating"><i class="fa fa-spinner fa-spin"></i></span>
                    <span v-else>Update</span>
                </button>

            </div>
      </div>
    </template>
  </customModal>
</template>
<script>
import { useI18n } from "vue-i18n";
import store from "../../store/index";
import axios from "axios";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import customModal from "../customModal/customModal.vue";
export default {
  setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    return { t, locale };
  },
  props: {
    visitobj: { type: Object, default: () => ({}) },
  },
  components: {
    customModal,
    flatPickr
  },
  data() {
    return {
      dateTimePickerConfig: {
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d\\TH:i",
        allowInput: true
      },
      baseurl: process.env.VUE_APP_Service_URL,
      isCreating: false,
      datetimefield: "",
      payload:{
  studyId: "",
  subjectId: "",
  visitNumber: "",
  plannedVisitDate: null,
  oldVisitDate: null
},
    };
  },
  async mounted() {
   console.log("visitobj in popup",this.visitobj);
   this.payload.studyId = this.visitobj.studyId;
   this.payload.subjectId = this.visitobj.patientId;
   this.payload.visitNumber = this.visitobj.visitNo;
   this.payload.oldVisitDate = this.visitobj.visitDate;
   this.datetimefield = this.toDateTimeInputValue(this.visitobj.visitDate);
   this.payload.plannedVisitDate = this.toApiDate(this.datetimefield);

  },
  methods: {
    toDateTimeInputValue(dateValue) {
      if (!dateValue) return "";
      const formatted = moment(dateValue).utc().format("YYYY-MM-DDTHH:mm");
      return formatted === "Invalid date" ? "" : formatted;
    },
    toApiDate(dateTimeValue) {
      if (!dateTimeValue) return null;
      const parsed = moment.utc(dateTimeValue, "YYYY-MM-DDTHH:mm", true);
      return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm:ss[Z]") : null;
    },
    async closeModal() {
      this.$emit("closeModal");
    },

    async createSchedule() {
      this.payload.plannedVisitDate = this.toApiDate(this.datetimefield);

      try {
        this.isCreating = true;
        const response = await axios.put(
          `${this.baseurl}/management/patientschedule/updatevisitdate`,
          this.payload,
          {
            headers: {
              Authorization: "Bearer " + store.getters.getIdToken,
              "Content-Type": "application/json"
            }
          }
        );

        alert("Visit updated successfully");
         this.$emit("cycleScheduled", {
          patientId: this.visitobj.patientId,
          cycleId: this.visitobj.cycleId
        });
        this.$emit("closeModal");
      } catch (err) {
          const message =
          err?.response?.data?.detail ||
          'Something went wrong';

          alert(message);
        } finally {
          this.isCreating = false;
        }
    }
  },
};
</script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
@import "../../assets/savepages.css";

</style>
